/*
 * Bonaventure Rental — contact form (CONTACT-1, 2026-08-21).
 *
 * Posts to our own endpoint instead of Shopify's {% form 'contact' %}, because the
 * Shopify form can only deliver to one address. Everything the visitor reads comes
 * from the strings block that Liquid injects (EN/JA), so this file holds no wording.
 *
 * 守っていること:
 *   - 二重送信をさせない（連打・Enter 連打で 2 通届かない）
 *   - 失敗を隠さない。届かなかったときは、直接のメールアドレスを画面に出す
 *   - JS が壊れてもページは壊さない（form 要素が無ければ何もしない）
 */
(function () {
  'use strict';

  function parseStrings(root) {
    var el = root.querySelector('[data-bvr-contact-strings]') ||
      document.querySelector('[data-bvr-contact-strings]');
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  /* 入力の検証。返すのはエラー**キー**で、文言は strings から引く（言語を JS に持たない）。 */
  function validate(values) {
    var errors = {};
    if (!values.name) errors.name = 'name';
    // サーバーと同じ緩さで見る。ここで厳しくしすぎると、実在するのに弾かれる人が出る。
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(values.email)) errors.email = 'email';
    if (values.message.length < 2) errors.message = 'message';
    return errors;
  }

  function setup(form) {
    var strings = parseStrings(form.ownerDocument);
    if (!strings) return;

    var endpoint = form.getAttribute('data-endpoint');
    var supportEmail = form.getAttribute('data-support-email') || '';
    var locale = form.getAttribute('data-locale') || '';
    var button = form.querySelector('[data-bvr-submit]');
    var result = form.querySelector('[data-bvr-result]');
    var busy = false;

    var field = function (name) { return form.querySelector('[data-bvr-field="' + name + '"]'); };
    var valueOf = function (name) {
      var el = field(name);
      return el ? String(el.value || '').trim() : '';
    };

    function fill(text) {
      return String(text || '').replace(/%EMAIL%/g, supportEmail);
    }

    function clearFieldErrors() {
      var nodes = form.querySelectorAll('[data-bvr-error-for]');
      for (var i = 0; i < nodes.length; i++) {
        nodes[i].hidden = true;
        nodes[i].textContent = '';
        var input = field(nodes[i].getAttribute('data-bvr-error-for'));
        if (input) input.removeAttribute('aria-invalid');
      }
    }

    function showFieldErrors(errors) {
      var first = null;
      Object.keys(errors).forEach(function (name) {
        var node = form.querySelector('[data-bvr-error-for="' + name + '"]');
        var input = field(name);
        if (node) {
          node.textContent = fill(strings.errors[errors[name]] || strings.errors.generic);
          node.hidden = false;
        }
        if (input) {
          input.setAttribute('aria-invalid', 'true');
          if (!first) first = input;
        }
      });
      if (first) first.focus();
    }

    function showResult(kind, html) {
      result.className = 'bvr-contact__msg bvr-contact__msg--' + (kind === 'ok' ? 'ok' : 'err');
      result.innerHTML = html;
      result.hidden = false;
    }

    function esc(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    /* 送信できなかったときは、必ず「直接のメールアドレス」を出す。
       ここで黙って失敗すると、お客様は送ったつもりのまま二度と書いてこない。 */
    function showFailure(key) {
      var text = fill(strings.errors[key] || strings.errors.generic);
      var html = esc(text);
      if (supportEmail) {
        html = html.replace(esc(supportEmail),
          '<a href="mailto:' + esc(supportEmail) + '">' + esc(supportEmail) + '</a>');
      }
      showResult('err', html);
    }

    function setBusy(on) {
      busy = on;
      if (!button) return;
      button.disabled = on;
      button.setAttribute('aria-busy', on ? 'true' : 'false');
      button.textContent = on ? strings.submitting : strings.submit;
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (busy) return;                      // 連打で 2 通送らない

      clearFieldErrors();
      result.hidden = true;

      var values = {
        name: valueOf('name'),
        email: valueOf('email'),
        phone: valueOf('phone'),
        order_number: valueOf('order_number'),
        message: valueOf('message'),
        company: valueOf('company'),         // ハニーポット（人は空のまま）
        locale: locale,
      };

      var errors = validate(values);
      if (Object.keys(errors).length) { showFieldErrors(errors); return; }

      setBusy(true);
      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(values),
      }).then(function (res) {
        return res.json().then(function (data) { return { status: res.status, data: data }; })
          .catch(function () { return { status: res.status, data: {} }; });
      }).then(function (r) {
        if (r.status === 200 && r.data && r.data.ok) {
          form.reset();
          showResult('ok',
            '<strong>' + esc(strings.success_title) + '</strong><br>'
            + esc(String(strings.success_body).replace(/%TICKET%/g, r.data.ticket || '')));
          setBusy(false);
          // 受け付けた後は押させない。同じ内容の 2 通目は、送る側にも受ける側にも意味がない。
          if (button) button.disabled = true;
          return;
        }
        setBusy(false);
        if (r.status === 400 && r.data && r.data.fields) {
          var map = {};
          r.data.fields.forEach(function (f) {
            // message_too_long はサーバー側だけが判定できる（上限は設定値）。本文欄に出す。
            map[f === 'message_too_long' ? 'message' : f] = f;
          });
          showFieldErrors(map);
          return;
        }
        if (r.status === 429) return showFailure('too_many');
        if (r.status === 502) return showFailure('delivery_failed');
        showFailure('generic');
      }).catch(function () {
        // ネットワークが落ちている・CORS で弾かれた等。送れていないので、成功に見せない。
        setBusy(false);
        showFailure('generic');
      });
    });
  }

  function init() {
    var forms = document.querySelectorAll('[data-bvr-contact]');
    for (var i = 0; i < forms.length; i++) setup(forms[i]);
  }

  // テストから純関数だけを触れるようにする（bvr-esim-order.js と同じ約束）。
  // 画面の文言は一切ここに無い — 見えるものは全部 Liquid から来る。
  if (typeof window !== 'undefined') window.BvrContact = { validate: validate };

  // 🔴 読み込んだだけで DOM に触らない。document が無い環境（テスト）でも落ちないこと自体が、
  //    「このファイルはページの他の部分を壊さない」という保証になっている。
  if (typeof document === 'undefined') return;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // テーマエディタでセクションを入れ替えたときにも効かせる。
  document.addEventListener('shopify:section:load', init);
})();
